import { createContext } from 'react'

/**
 * Context containing the app configuration.
 */
export const UserPHIContext = createContext()

export default UserPHIContext
